import React from 'react'
import { WarningAmberOutlined } from '@mui/icons-material'
import { alarmSummaryErrorCount } from './machineAlarmUtils'

/**
 * MachineAlarmBadge — card badge (contract §10.1). PO refinement (2026-07-10): the card
 * badge flags ERRORS only — it shows the ERR count and is coloured red. WAR/INF alarms
 * must NOT make a machine read as errored on the grid (they still appear in full in the
 * detail alarms panel). Fed by the snapshot-embedded `device.alarmSummary`
 * ({ err, war, inf }); renders nothing when there is no active ERR alarm.
 *
 * @param {{summary?: object, testId?: string}} props
 */
export default function MachineAlarmBadge ({ summary, testId }) {
  const errors = alarmSummaryErrorCount(summary)
  if (errors === 0) return null
  return (
    <span className='mcx-alarm-badge mcx-alarm-badge--ERR' data-testid={testId}>
      <WarningAmberOutlined sx={{ fontSize: 14 }} />
      {errors}
    </span>
  )
}
